import React from "react";
import PropTypes from "prop-types";
import lockIcon from "assets/images/lockimage.svg";

// eslint-disable-next-line no-unused-vars
function ListingTitle({ title, showIcon, cssName, fontColor }) {
  return (
    <div className="b-listing-container__padding-top">
      {showIcon === "true" && (
        <img className="b-listing-container__lock-icon" src={lockIcon} alt="" />
      )}
      <h1 className={`dafault-font-family-bold ${cssName}`}>{title}</h1>
      {showIcon === "true" && (
        <div className="b-listing-container__locked-divider" />
      )}
      {showIcon === "false" && <div className="b-listing-container__divider" />}
    </div>
  );
}
ListingTitle.propTypes = {
  title: PropTypes.string.isRequired,
  cssName: PropTypes.string,
  showIcon: PropTypes.string.isRequired,
  fontColor: PropTypes.string.isRequired,
};

ListingTitle.defaultProps = {
  cssName: "b-listing-container__title",
};

export default ListingTitle;
